import PassageTest from './PassageTest';
export default PassageTest;